module.exports = __webpack_public_path__ + "img/tl.64d8a9d8.svg";